<template>
  <svg :width="`${width}px`" :height="`${height}px`">
    <path d="m6.62307,0.16328l15.90642,0l0,2.39394l-15.90642,0l0,-2.39394zm-5.37307,0l2.97913,0l0,2.39394l-2.97913,0l0,-2.39394zm5.37307,5.31988l15.90642,0l0,2.39394l-15.90642,0l0,-2.39394zm-5.37307,0l2.97913,0l0,2.39394l-2.97913,0l0,-2.39394zm5.37307,5.31987l15.90642,0l0,2.39394l-15.90642,0l0,-2.39394zm-5.37307,0l2.97913,0l0,2.39394l-2.97913,0l0,-2.39394zm0.22052,5.31988l2.97913,0l0,2.39394l-2.97913,0l0,-2.39394zm5.15256,5.31987l15.90642,0l0,2.39394l-15.90642,0l0,-2.39394zm-5.15256,0l2.97913,0l0,2.39394l-2.97913,0l0,-2.39394zm5.37307,-5.31987l15.90642,0l0,2.39394l-15.90642,0l0,-2.39394z"/>
  </svg>
</template>

<script>
export default {
  name: 'Forms',
  props: {
    width: {
      default: 24,
      type: Number
    },
    height: {
      default: 24,
      type: Number
    },   
  },
}
</script>


<style scoped lang="scss">
svg {
  fill: #2c3e50;
  stroke-width: 0;
}
</style>
